{
  "formLabels": {
    "physicalAddress": "Physical Address",
    "language": "Language"
  },
  "profile": {
    "details": "Details",
    "employment": "Employment",
    "compliance": "Compliance",
    "suitability": "Suitability",
    "idVerification": "ID Verification",
    "successMessages": {
      "details": "Customer’s Personal Details have been updated.",
      "employment": "Customer’s Employment Details have been updated.",
      "compliance": "Customer’s Compliance Details have been updated.",
      "suitability": "Customer’s Suitability Details have been updated.",
      "id": "Customer’s ID has been updated."
    },
    "fieldValidations": {
      "noEmpty": "Cannot be empty",
      "phone": "Phone number, if present, must be 10 digits long.",
      "canadianNumberValidation": "Phone number is not a valid Canadian or USA phone format",
      "primaryEmail": "Email has to be properly formatted.",
      "number": "Must be a number",
      "sin": "The social insurance number must be 9 digits long.",
      "pleaseEnterValidTaxId": "Please Enter Valid Tax ID",
      "addressOutOfJurisdictionMessage": "We're sorry, but the address entered is outside our supported area ({{ALLOWED_JURISDICTIONS}}).",
      "liquidAssetsRequired": "Liquid assets are required"
    },
    "helpText": {
      "email": "Email: Used for login",
      "phone": "Phone number: Used for login"
    }
  },
  "authCredentialsUpdateConfirmation": {
    "email": {
      "title": "Are you sure you want to update the client's email?",
      "subtitle": "Are you sure you want to update the client's email? They will be required to use this new email the next time they log into their account."
    },
    "phone": {
      "title": "Are you sure you want to update the client's phone number?",
      "subtitle": "Are you sure you want to update the client's phone number? They will be required to use this new phone number the next time they log into their account."
    },
    "emailAndPhone": {
      "title": "Are you sure you want to update the client's email and phone number?",
      "subtitle": "Are you sure you want to update the client's email and phone number? They will be required to use this new email and phone number the next time they log into their account."
    }
  },
  "confirmationDialog": {
    "title": "You are about to set ID to ‘Not Verified’",
    "subtitle": "Changing this may require the client to re-verify their ID before they can access the client app.",
    "continueButton": "Continue",
    "cancelButton": "Cancel",
    "warning": "This client is missing a verified ID"
  },
  "copied": "Copied",
  "previousLabel": "Previous {{label}}",
  "details": {
    "trustedContact": {
      "noEmpty": "Cannot be empty",
      "emailFormatting": "Email has to be properly formatted.",
      "phoneFormatting": "Phone number has to be properly formatted.",
      "name": "Name",
      "email": "Email",
      "phone": "Phone",
      "address": "Address",
      "relation": "Relation",
      "title": "Trusted Contact Person",
      "relationOptions": {
        "CHILD": "Child",
        "FRIEND": "Friend",
        "GRANDPARENT": "Grandparent",
        "OTHER": "Other",
        "PARENT": "Parent",
        "SIBLING": "Sibling",
        "SPOUSE": "Spouse"
      },
      "notAvailableMeta": {
        "header": "No trusted contact person available",
        "body": "You can add trusted contact person information here"
      }
    },
    "needsToBeFilled": "Needs to be filled",
    "placeholders": {
      "issueSource": "Write the issue source here",
      "companySymbol": "Write the company symbol here",
      "registrationNumber": "Write the registration number here",
      "selectAnOption": "Select an option",
      "selectRiskLevel": "Select a new risk level for the client",
      "note": "Write a note about the change"
    },
    "errorMessages": {
      "notSelected": "Not selected",
      "profileIncomplete": "<b>Action required!</b> Fields in this section need completing",
      "fieldsToBeFilled": "<b>Action required!</b> There are some fields that need to be filled."
    },
    "profileStatusBox": {
      "header": "Profile Status",
      "annualCheckStatusTitle": "Annual Information Check Status",
      "clientAgreementsAreReadyToSignTitle": "Client agreements are ready to sign",
      "approved": "Approved",
      "overdue": "Overdue",
      "lastCheckDate": "Date of Information Update",
      "notAvailableMeta": {
        "header": "No profile status available",
        "body": "You need to add the required information to show the client status."
      }
    },
    "spouseInformationBox": {
      "header": "Spouse Information",
      "spouseFirstName": "First Name",
      "spouseMiddleName": "Middle Name",
      "spouseLastName": "Last Name",
      "spouseJobTitle": "Job Title",
      "spouseCompanyType": "Company type",
      "spouseEmployerName": "Employer Name",
      "spouseEmploymentType": "Employment Type",
      "spouseAddress": "Address",
      "spouseEmail": "Email",
      "requiredMeta": {
        "header": "Information required",
        "buttonText": "ADD DATA"
      }
    },
    "employmentBox": {
      "header": "Employment",
      "requiredMeta": {
        "header": "Information required",
        "buttonText": "ADD DATA"
      },
      "employmentStatusTitle": "Employment Status",
      "jobTitle": "Job Title",
      "companyTypeTitle": "Company Type",
      "studentAreaOfStudy": "Area of Study",
      "employerNameTitle": "Company Name",
      "employerCompanyAddressTitle": "Company Address",
      "employmentSituationTitle": "Employment Situation",
      "employmentSituationOtherDescriptionTitle": "Employment Situation Description",
      "previous": {
        "jobTitle": "Previous Job Title",
        "companyTypeTitle": "Previous Company Type",
        "employerNameTitle": "Previous Company Name",
        "employerCompanyAddressTitle": "Previous Company Address"
      },
      "taxIdTypeTitle": "Tax ID Type"
    },
    "entityInformation": {
      "header": "Entity Information",
      "countryOfRegistration": "Country of Registration",
      "registrationNumber": "Registration №"
    },
    "riskLevelBox": {
      "header": "FinCrime Risk Score: {{riskLevel}}",
      "riskLevel": {
        "0": "High Risk Country or Occupation",
        "1": "Low",
        "2": "Medium",
        "3": "High"
      },
      "notAvailableMeta": {
        "header": "Risk level can't be generated",
        "body": "You need to complete the client profile to generate a risk level"
      },
      "reason": "Reason",
      "previousChangeQuestion": "Any previous manual changes to risk level?",
      "overrideExistingLevel": "Override existing client risk level?",
      "newFraudRiskScore": "New fraud risk score",
      "notes": "Notes"
    },
    "idVerificationBox": {
      "header": "ID Verification",
      "addIDVerification": "Add - ID Verification",
      "updateIDVerification": "Update - ID Verification",
      "modalBoxPredix": "Create",
      "idVerifiedLabel": "ID Verified",
      "idNotVerifiedLabel": "ID not verified",
      "requiredMeta": {
        "header": "ID information required",
        "buttonText": "ADD DATA"
      },
      "typeTitle": "TYPE",
      "jurisdictionTitle": "JURISDICTION",
      "expiryDate": "EXPIRY DATE",
      "methodOfIdVerification": "METHOD OF ID VERIFICATION"
    },
    "clientFeesBox": {
      "header": "Client Fees",
      "requiredMeta": {
        "header": "Information required",
        "buttonText": "SET FEES"
      },
      "feeGridTitle": "Fee Grid",
      "billingCycleTitle": "Billing Cycle",
      "organizationDefault": "Organization Default"
    },
    "suitabilityBox": {
      "suitabilityScoreNotAvailableLabel": "Suitability Score: not available",
      "suitabilityScoreLabel": "Suitability Score: {{suitabilityScore}}",
      "requiredMeta": {
        "header": "The suitability score will be generated after the information has been added.",
        "buttonText": "ADD DATA"
      },
      "annualIncomeTitle": "Annual Income",
      "annualIncomeRangeTitle": "Annual Income Range",
      "totalLiquidAssetsTitle": "Total Liquid Assets",
      "totalFixedAssetsTitle": "Total Fixed Assets",
      "totalDebtTitle": "Total Debt",
      "annualDebtPaymentsTitle": "Annual Debt Payments",
      "isAccreditedInvestorTitle": "Accredited Investor",
      "investmentKnowledgeTitle": "Investment Knowledge",
      "riskQuestion1Title": "Risk Question 1",
      "riskQuestion2Title": "Risk Question 2",
      "sourceOfWealthTitle": "Source Of Wealth",
      "sourceOfFundsTitle": "Source Of Funds",
      "uniqueCircumstancesTitle": "Unique Circumstances",
      "none": "None",
      "sourceOfWealthOtherDescriptionTitle": "Source of Weath Description",
      "sourceOfFundsOtherDescriptionTitle": "Source of Funds Description"
    },
    "citizenshipAndTaxStatusInformationBox": {
      "individualHeader": "Marital, Citizenship and Tax Status",
      "nonIndividualHeader": "Tax Status",
      "maritalStatusTitle": "Marital Status",
      "numberOfDependents": "Number of Dependents",
      "citizenshipsTitle": "Citizenships",
      "countryOfTaxResidenceTitle": "Country of tax residence",
      "foreignTaxInformationTitle": "Foreign Tax Information",
      "countryTitle": "COUNTRY",
      "taxIdentificationNumberTitle": "TAX IDENTIFICATION NUMBER",
      "taxNumber": "Tax №",
      "yearEnd": "Year-end date"
    },
    "personAndEntitiesOfInterestBox": {
      "header": "Person and Entities of Interest",
      "officerOfAPublicCompanyTitle": "Officer of a Public Company",
      "ownerOfPublicCompanyTitle": "Owner of Public Company",
      "publicCompanySymbol": "Public Company Symbol",
      "memberOfIIROCTitle": "Member of IIROC",
      "IIROCCompanySymbolTitle": "IIROC Company Symbol",
      "politicallyExposedDomesticPersonTitle": "Politically Exposed Domestic Person",
      "politicallyExposedForeignPersonTitle": "Politically Exposed Foreign Person",
      "closeAssociateOfPEPTitle": "Close Associate of PEP",
      "powerOfAttorneyGrantedTitle": "Power Of Attorney Granted",
      "complianceStateTitle": "Compliance State",
      "headOfInternationalOrganizationTitle": "Head of International Organization",
      "complianceIssueSourceTitle": "Compliance Issue Source",
      "diminishedCapacityTitle": "Diminished Capacity",
      "isVulnerablePerson": "Vulnerable Person",
      "isOwnerOfEntity": "Owner of Entity"
    },
    "entityOfInterestBox": {
      "header": "Entity of Interest",
      "isNonProfitTitle": "Non-profit",
      "receivesDonationsFromPublic": "Solicits Donations from Public",
      "isRegisteredWithCRATitle": "Registered with CRA",
      "charityRegistrationNumber": "Charity Registration №",
      "isEntityRegulatedTitle": "Regulated",
      "regulatorNameTitle": "Regulator Name",
      "regulatorRegistrationNumber": "Regulator Registration №",
      "isReportingIssuerTitle": "Reporting Issuer",
      "issuerNameTitle": "Issuer Name",
      "issuerTickerTitle": "Issuer Ticker",
      "issuerExchangeTitle": "Issuer Exchange",
      "isAFinancialEntityTitle": "A financial entity or related company",
      "isAffiliateOfFinancialEntityTitle": "An affiliate of a financial entity",
      "instructionsFromFinancialEntityTitle": "Instructions authorized by a financial entity",
      "isPublicBodyTitle": "Public body",
      "isForThirdPartyTitle": "For Third Party",
      "isLargeCorporation": "Very Large Corporation"
    },
    "relationOptions": {
      "CHILD": "Child",
      "FRIEND": "Friend",
      "GRANDPARENT": "Grandparent",
      "OTHER": "Other",
      "PARENT": "Parent",
      "SIBLING": "Sibling",
      "SPOUSE": "Spouse",
      "COMMON_LAW": "Common Law",
      "GRANDCHILD": "Grandchild",
      "GUARDIAN": "Guardian",
      "NEPHEW_NIECE": "Nephew/Niece",
      "PRIMARY_CAREGIVER": "Primary Caregiver"
    },
    "editClientDetail": "Edit client details",
    "editNonIndivEntityDetail": "Update Non-individual Entity",
    "riskLevel": "Risk Level",
    "idVerification": "ID Verification",
    "firstName": "First Name",
    "middleName": "Middle Name",
    "lastName": "Last Name",
    "allocation": "Allocation",
    "entityName": "Entity Name",
    "clientName": "Client name",
    "primaryEmail": "Email",
    "phone": "Phone",
    "country": "Country",
    "province": "Province",
    "city": "City",
    "preferredLanguages": "Preferred Language",
    "dateOfBirth": "Date of Birth",
    "dateOfDeath": "Date of Death",
    "establishedDate": "Established",
    "numClientsInEntity_one": "1 client in this entity",
    "numClientsInEntity_other": "{{count}} clients in this entity",
    "inProvinceSince": "In Province Since",
    "physicalAddress": "Address",
    "gender": "Gender",
    "state": {
      "FROZEN": "Frozen",
      "ACTIVE": "Active",
      "INACTIVE": "Inactive"
    },
    "stateTooltip": {
      "FROZEN": "Frozen client cannot initiate any transfers. Click the ellipsis menu on the right to change the client status to active.",
      "INACTIVE": "This client has been permanently deactivated."
    },
    "idVerificationNotCompletedTooltip": "Add an ID verification inside the details tab.",
    "complianceStateNotApprovedTooltip": "Go to the details tab to approve the client’s compliance details.",
    "incompleteProfileTooltip": "Go to the details tab and update the incomplete information",
    "allDocumentSigned": "All documents signed",
    "unsignedDocuments_one": "1 unsigned document",
    "unsignedDocuments_other": "{{count}} Unsigned documents",
    "unsignedDocumentsTooltip": "Sign the documents by going to the documents tab.",
    "annualInfoUpToDate": "Annual information updated",
    "annualInfoNeedsReview": "Annual information update",
    "suitabilityReviewOverdue": "Last suitability review took place {{months}} months ago.",
    "annualInfoNeedsReviewNotice": "Annual information update — Last suitability review took place {{months}} months ago.",
    "complianceStateNeedsReview": "Compliance state needs review",
    "annualInfoNeedsReviewTooltip": "Last suitability review took place {{months}} months ago. Update the client's information by selecting the edit button on the profile status inside the details tab.",
    "freeze": "Freeze",
    "activate": "Activate",
    "deactivate": "Deactivate",
    "deactivationConfirmation": {
      "title": "Do you want to deactivate {{clientName}}?",
      "body": "This action can't be undone."
    },
    "transitionUser": "Select Transition",
    "maritalStatus": "Marital Status",
    "clientsStatus": "Client's Status History",
    "viewClientStatus": "View Client Status History",
    "employmentStatus": "Employment Status",
    "jobTitle": "Job Title",
    "companyType": "Company Type",
    "employerName": "Company Name",
    "employerCompanyAddress": "Company Address",
    "employmentSituation": "Employment Situation",
    "relation": "Relation",
    "studentAreaOfStudy": "Area of Study",
    "sin": "SIN",
    "isOfficerOfPublicCompany": "Officer of Public Company",
    "isOwnerOfPublicCompany": "Owner of Public Company",
    "isMemberOfIiroc": "Member of IIROC",
    "politicallyExposedForeignPerson": "Politically Exposed Foreign Person",
    "politicallyExposedDomesticPerson": "Politically Exposed Domestic Person",
    "closeAssociateOfPEP": "Close Associate of PEP",
    "powerOfAttorneyGranted": "Power Of Attorney Granted",
    "headOfInternationalOrganization": "Head Of International Organization",
    "ssSymbols": "Public Company Symbol",
    "insiderSymbols": "IIROC company Symbol",
    "sinPlaceholder": "Will not show, update only",
    "complianceState": "Compliance State",
    "complianceIssueSource": "Compliance Issue Source",
    "annualIncomeCents": "Annual Income",
    "financialLiquidAssetsCents": "Total Liquid Assets",
    "financialFixedAssetsCents": "Total Fixed Assets",
    "totalDebtCents": "Total Debt",
    "annualDebtPaymentsCents": "Annual Debt Payments",
    "investmentKnowledge": "Investment Knowledge",
    "updateGoal": "Update Goal",
    "addID": "Add - ID Verification",
    "updateID": "Update - ID Verification",
    "riskQuestion1": "Risk Question 1",
    "riskQuestion1Answer": {
      "LEVEL_5": "Maximize Gains",
      "LEVEL_3": "Both Equally",
      "LEVEL_1": "Minimize Losses"
    },
    "riskQuestion2": "Risk Question 2",
    "riskQuestion2Answer": {
      "LEVEL_4": "Do nothing",
      "LEVEL_3": "Take out some money",
      "LEVEL_2": "Take out some money",
      "LEVEL_1": "Take out all money",
      "LEVEL_5": "Invest more"
    }
  },
  "editClientOrganization": {
    "moveClientToAnotherOrganization": "Move client to another organization",
    "currentOrganization": "Current Organization",
    "cannotMoveHouseholdMembers": "Clients who are members of a household or corporation can't be moved.",
    "confirmationTitle": "Are you sure you want to update the client’s organization?",
    "confirmationSubtitle": "They will be assigned to the new organization which may impact reporting, login, portfolios or other configurations.",
    "updatedToastMessage": "Client {{clientName}} has been moved to a new organization.",
    "selectOrganization": "Select Organization"
  },
  "menu": {
    "editProfile": "Edit profile",
    "moveToAnotherOrganization": "Move to another organization",
    "copyProfileURL": "Copy profile URL",
    "freezeClient": "Freeze client",
    "copyID": "Copy ID",
    "addToHousehold": "Add to a household"
  },
  "form": {
    "update": "Update",
    "edit": "Edit",
    "add": "Add"
  },
  "edit": {
    "goal": {
      "updatedToastMessage": "Goal has been updated.",
      "applyPortfolioAtGoal": "Apply portfolio at goal",
      "noPermissions": "You don't have permission to edit a goal"
    },
    "buttons": {
      "save": "Save"
    },
    "complianceStateOptions": {
      "APPROVED": "Approved",
      "NEEDS_REVIEW": "Needs review",
      "REJECTED": "Rejected"
    },
    "debtAssociatedOptions": {
      "MORTGAGE": "Mortgage",
      "CREDIT_CARD": "Credit Card",
      "STUDENT_LOAN": "Student Loan"
    },
    "employmentStatusOptions": {
      "EMPLOYED": "Employed",
      "SELF_EMPLOYED": "Self employed",
      "RETIRED": "Retired",
      "UNEMPLOYED": "Unemployed",
      "STUDENT": "Student",
      "STAY_AT_HOME_PARENT": "Homemaker"
    },
    "fatcaStatus": "FATCA Status",
    "fatcaStatusOptions": {
      "PUBLICLY_TRADED_NFFE": "Publicly traded NFFE",
      "INTERNATIONAL_ORGANIZATION": "International organization",
      "GOVERNMENT": "Government",
      "CENTRAL_BANK": "Central bank",
      "ACTIVE_NFFE": "Active NFFE",
      "PASSIVE_NFFE": "Passive NFFE",
      "OTHER": "Other"
    },
    "fatcaStatusOtherDescription": "FATCA Status Other Description",
    "employmentSituationOptions": {
      "STABLE_AND_SECURE": "Stable and secure",
      "STABLE_BUT_MAY_CHANGE_IN_FUTURE": "Stable but may change in the future",
      "SOMEWHAT_STABLE": "Somewhat stable",
      "UNEMPLOYED_BUT_LOOKING": "Unemployed but looking",
      "OTHER": "Other"
    },
    "relationOptions": {
      "CHILD": "Child",
      "FRIEND": "Friend",
      "GRANDPARENT": "Grandparent",
      "OTHER": "Other",
      "PARENT": "Parent",
      "SIBLING": "Sibling",
      "SPOUSE": "Spouse"
    },
    "scoreOptions": {
      "0": "High Risk Country or Occupation",
      "1": "Low",
      "2": "Medium",
      "3": "High"
    },
    "preferredMethodOfCommunicationOptions": {
      "EMAIL": "Email",
      "PHONE": "Phone",
      "TEXT": "Text",
      "OTHER": "Other"
    },
    "maritalStatusOptions": {
      "SINGLE": "Single",
      "MARRIED": "Married",
      "COMMON_LAW": "Common Law",
      "DIVORCED": "Divorced",
      "SEPARATED": "Separated",
      "WIDOWED": "Widowed",
      "CIVIL_UNION": "Civil Union"
    },
    "documentIssuingJurisdicationOptions": {
      "ALBERTA": "Alberta",
      "BRITISH_COLUMBIA": "British Columbia",
      "MANITOBA": "Manitoba",
      "NEW_BRUNSWICK": "New Brunswick",
      "NEW_FOUNDLAND_AND_LABRADOR": "Newfoundland and Labrador",
      "NOVA_SCOTIA": "Nova Scotia",
      "ONTARIO": "Ontario",
      "PRINCE_EDWARD_ISLAND": "Prince Edward Island",
      "SASKATCHEWAN": "Saskatchewan",
      "QUEBEC": "Quebec",
      "YUKON": "Yukon",
      "NORTH_WEST_TERRITORIES": "Northwest Territories",
      "NUNAVUT": "Nunavut",
      "FEDERAL": "Federal",
      "OTHER": "Other"
    },
    "jurisdicationOptionsForUsandCanada": {
      "ALBERTA": "Alberta",
      "BRITISH_COLUMBIA": "British Columbia",
      "MANITOBA": "Manitoba",
      "NEW_BRUNSWICK": "New Brunswick",
      "NEW_FOUNDLAND_AND_LABRADOR": "Newfoundland and Labrador",
      "NOVA_SCOTIA": "Nova Scotia",
      "ONTARIO": "Ontario",
      "PRINCE_EDWARD_ISLAND": "Prince Edward Island",
      "SASKATCHEWAN": "Saskatchewan",
      "QUEBEC": "Quebec",
      "YUKON": "Yukon",
      "NORTH_WEST_TERRITORIES": "Northwest Territories",
      "NUNAVUT": "Nunavut",
      "FEDERAL": "Federal",
      "ALASKA": "Alaska",
      "ALABAMA": "Alabama",
      "ARIZONA": "Arizona",
      "ARKANSAS": "Arkansas",
      "CALIFORNIA": "California",
      "COLORADO": "Colorado",
      "CONNECTICUT": "Connecticut",
      "DELAWARE": "Delaware",
      "DISTRICT_OF_COLUMBIA": "District of Columbia",
      "FLORIDA": "Florida",
      "GEORGIA": "Georgia",
      "GUAM": "Guam",
      "HAWAII": "Hawaii",
      "IDAHO": "Idaho",
      "ILLINOIS": "Illinois",
      "INDIANA": "Indiana",
      "IOWA": "Iowa",
      "KANSAS": "Kansas",
      "KENTUCKY": "Kentucky",
      "LOUISIANA": "Louisiana",
      "MAINE": "Maine",
      "MARSHALL_ISLAND": "Marshall Islands",
      "MICHIGAN": "Michigan",
      "MARYLAND": "Maryland",
      "MASSACHUSETTS": "Massachusetts",
      "MINNESOTA": "Minnesota",
      "MISSISSIPPI": "Mississippi",
      "MISSOURI": "Missouri",
      "MONTANA": "Montana",
      "NEBTASKA": "Nebraska",
      "NEVADA": "Nevada",
      "NEW_HAMPSHIRE": "New Hampshire",
      "NEW_JERSEY": "New Jersey",
      "NEW_MEXICO": "New Mexico",
      "NEW_YORK": "New York",
      "NORTH_CAROLINA": "North Carolina",
      "NORTH_DAKOTA": "North Dakota",
      "OHIO": "Ohio",
      "OKLAHOMA": "Oklahoma",
      "OREGON": "Oregon",
      "PALAU": "Palau",
      "PENNSYLVANIA": "Pennsylvania",
      "PUERTO_RICO": "Puerto Rico",
      "RHODE_ISLAND": "Rhode Island",
      "SOUTH_CAROLINA": "South Carolina",
      "SOUTH_DAKOTA": "South Dakota",
      "TENNESSEE": "Tennessee",
      "TEXAS": "Texas",
      "UTAH": "Utah",
      "US_VIRGIN_ISLAND": "U.S. Virgin Islands",
      "VERMONT": "Vermont",
      "VIGINIA": "Virginia",
      "WASHINGTON": "Washington",
      "WEST_VIRGINIA": "West Virginia",
      "WINSCONSIN": "Wisconsin",
      "WYOMING": "Wyoming",
      "US": "United States",
      "CA": "Canada",
      "OTHER": "Other"
    },
    "noJurisdication": "N/A",
    "noJDocumentType": "N/A",
    "noExpiryDate": "N/A",
    "methodOfIDVerificationOptions": {
      "CREDIT_CHECK": "Credit Check",
      "DIGITAL_DOCUMENT_CHECK": "Digital Document Check",
      "DUAL_METHOD": "Dual Process Method",
      "IN_PERSON_VALIDATION": "In Person ID Card Check",
      "CONFIRMATION_OF_EXISTENCE": "Confirmation of Existence"
    },
    "investmentKnowledgeOptions": {
      "NONE": "None",
      "LIMITED": "Limited",
      "SOME": "Some",
      "EXPERT": "Expert"
    },
    "riskQuestion1Options": {
      "LEVEL_1": "Level 1",
      "LEVEL_2": "Level 2",
      "LEVEL_3": "Level 3",
      "LEVEL_4": "Level 4",
      "LEVEL_5": "Level 5"
    },
    "riskQuestion2Options": {
      "LEVEL_1": "Level 1",
      "LEVEL_2": "Level 2",
      "LEVEL_3": "Level 3",
      "LEVEL_4": "Level 4",
      "LEVEL_5": "Level 5"
    },
    "sourceOfWealthOptions": {
      "EMPLOYMENT_INCOME": "Employment Income",
      "SALE_OF_LARGE_ASSET": "Sale of Large Asset",
      "PROPERTY_SALE": "Property Sale",
      "INHERITANCE": "Inheritance",
      "FAMILY_ESTATE": "Family Estate",
      "INVESTMENT": "Investment",
      "BUSINESS_OWNERSHIP_INTEREST": "Business Ownership Interest",
      "DEBT": "Debt",
      "LOTTERY_WINNING": "Lottery Winning",
      "OTHER": "Other"
    },
    "sourceOfFundsOptions": {
      "CONTRIBUTIONS": "Contributions",
      "DEBT": "Debt",
      "DONATIONS": "Donations",
      "EMPLOYMENT_INCOME": "Employment Income",
      "INCOME_OR_WORKING_CAPITAL": "Income of Working Capital",
      "INHERITANCES_AND_GIFT": "Inheritances and Gift",
      "LOTTERY_WINNING": "Lottery Winning",
      "OTHER": "Other",
      "PENSION_RELEASE": "Pension Release",
      "PERSONAL_SAVINGS": "Personal Savings",
      "PROCEEDS_FROM_INVESTMENTS": "Proceeds from Investments",
      "PROPERTY_SALE": "Property Sale",
      "SALE_OF_LARGE_ASSET": "Sale of Large Asset",
      "SHARES_SALES_AND_DIVIDENDS": "Shares Sales and Dividends"
    },
    "typeOfTrustOptions": {
      "COMPLEX": "Complex Trust",
      "SIMPLE": "Simple Trust",
      "GRANTOR": "Grantor Trust"
    }
  },
  "tabs": {
    "overview": "Overview",
    "details": "Details",
    "relationships": "Relationships",
    "goals": "Goals",
    "accounts": "Accounts",
    "agreements": "Agreements",
    "documents": "Documents",
    "bankAccounts": "Bank Accounts",
    "activity": "Activity",
    "performance": "Performance",
    "profile": "Profile",
    "transfers": "Transfers",
    "trades": "Trades",
    "ledger": "Ledger",
    "statements": "Statements",
    "notes": "Notes",
    "audit_log": "Audit Log",
    "organization_user_entities": "Access"
  },
  "audit": {
    "changedBy": "Changed By",
    "clientName": "Client Name",
    "type": "Type",
    "changedObject": "Changed Object",
    "changedFields": "Changed Fields",
    "timestamp": "Timestamp",
    "from": "From",
    "to": "To",
    "field": "Field",
    "detailDate": "Date",
    "detailTraceId": "Trace",
    "detailObjectIdLabel": "{{changedObject}} id",
    "detailObjectIdLabelFallback": "id",
    "detailChangedByEmail": "Changed by",
    "productName": "Product Name",
    "ticker": "Ticker",
    "errorLoading": "Could not load audit log",
    "noClientFound": "No client found",
    "searchFailed": "Could not search for client. Please try again.",
    "toolbar": {
      "clientSearch": "Client search",
      "apply": "Apply",
      "filters": {
        "date": "Date selector",
        "changedBy": "Changed by",
        "clientName": "Client name",
        "type": "Type",
        "changedObject": "Changed object"
      }
    },
    "filters": {
      "clientName": "Client name",
      "type": "Type",
      "date": "Date",
      "dateFrom": "From",
      "dateTo": "To",
      "invalidDateRange": "End date must be on or after start date",
      "changedBy": "Changed by",
      "changedBySearch": "Search changed by",
      "noChangedByOptions": "No changed-by options in loaded results",
      "changedObject": "Changed object",
      "changedObjectSearch": "Search changed object",
      "noChangedObjectOptions": "No changed-object options in loaded results",
      "clientNameSearch": "Search clients",
      "noClientNameOptions": "No clients in loaded results",
      "maxClientNamesSelected": "Maximum {{max}} clients can be selected",
      "maxTypesSelected": "Maximum {{max}} types can be selected",
      "maxChangedBySelected": "Maximum {{max}} changed-by actors can be selected",
      "maxChangedObjectsSelected": "Maximum {{max}} changed objects can be selected"
    }
  },
  "userChangesOnly": "User Changes Only",
  "moreFields": "more fields",
  "completed": "Profile completed",
  "notCompleted": "Profile not completed",
  "idVerified": "verified",
  "idNotVerified": "not verified",
  "suitabilityScore": "Suitability score",
  "theme": "Theme",
  "idTable": {
    "documentId": "ID",
    "documentType": "Type",
    "methodOfIDVerification": "Method",
    "documentIssuingJurisdication": "Jurisdication",
    "documentExpiryDate": "Expiry Date",
    "verifiedDate": "Verified"
  },
  "none": "None",
  "cash": "Cash",
  "accountNumber": "Account Number",
  "accountName": "Account Name",
  "subAccountState": {
    "AWAITING_APPROVAL": "Awaiting Approval",
    "ACTIVE": "Active",
    "INACTIVE": "Inactive",
    "PENDING": "Pending",
    "CLOSED": "Closed"
  },
  "marketValue": "Total Assets",
  "account": "Account",
  "subAccount": "Sub-account",
  "subAccountWithSuffix": "Sub-account {{suffix}}",
  "accountGroup": "Account Group",
  "client": "Client",
  "entity": "Entity",
  "clientGroup": "ClientGroup",
  "goal": "Goal",
  "groupBy": "Group By",
  "security": "Security",
  "primaryAssetClass": "Primary Asset Class",
  "secondaryAssetClass": "Secondary Asset Class",
  "tertiaryAssetClass": "Tertiary Asset Class",
  "ofTotal": "of total",
  "na": "N/A",
  "goalTypes": "Goal Type",
  "goalName": "Goal Name",
  "goalType": {
    "CAR": "Car",
    "BUILD_WEALTH": "Build Wealth",
    "RETIREMENT": "Retirement",
    "MAJOR_PURCHASE": "Major Purchase",
    "HOUSE": "House",
    "EDUCATION": "Education",
    "VACATION": "Vacation",
    "START_A_BUSINESS": "Start a Business",
    "WEDDING": "Wedding",
    "PARENTAL_LEAVE": "Parental Leave",
    "SAFETY_NET": "Safety Net",
    "OTHER": "Other",
    "CASH_RESERVE": "Cash Reserve",
    "LEGACY": "Legacy",
    "GROUP": "Group",
    "RETIREMENT_INCOME": "Retirement Income"
  },
  "accountType": "Account Type",
  "selectGoal": "Select Goal",
  "editName": "Name",
  "newIDVerification": "New ID Verification",
  "methodOfIDVerification": "Method Of ID Verification",
  "firstDocument": "First Document",
  "secondDocument": "Second Document",
  "noIds": "No ID verification documents",
  "idVerificationMethods": {
    "CREDIT_CHECK": "Credit Check",
    "DIGITAL_DOCUMENT_CHECK": "Digital Document Check",
    "DUAL_METHOD": "Dual Method",
    "IN_PERSON_VALIDATION": "In Person Validation"
  },
  "documentType": "Document Type",
  "documentTypesLabels": {
    "creditCheckDocumentTypes": "Please select the documents you would like to support",
    "digitalDocumentTypes": "Please select the digital verification documents you would like to support",
    "dualVerificationTypes": "Please select the dual verification documents you would like to support",
    "inPersonVerificationTypes": "Please select the in-person verification documents you would like to support"
  },
  "documentTypes": {
    "BANK_STATEMENT": "Bank Statement",
    "BENEFITS_STATEMENT": "Benefits Statement",
    "BIRTH_CERTIFICATE": "Birth Certificate",
    "CREDIT_BUREAU": "Credit Bureau",
    "CAD_CREDIT_BUREAU_PRODUCT": "Credit Bureau",
    "CANADA_411": "Canada 411",
    "CITIZENSHIP_CARD": "Citizenship Card",
    "CITIZENSHIP_CERTIFICATE": "Citizenship Certificate",
    "CONFIRMATION_FROM_FINANCIAL_ENTITY": "Confirmation from Financial Entity",
    "CREDIT_CARD_STATEMENT": "Credit Card Statement",
    "CREDIT_FILE": "Credit File",
    "DIVORCE_DOCUMENTATION": "Divorce Documentation",
    "DRIVERS_LICENSE": "Drivers License",
    "GLOBAL_ENTRY_CARD": "Global Entry Card",
    "GOV_ISSUED_CPP_STATEMENT": "Government Issued CPP Statement",
    "GOV_ISSUED_VEHICLE_REGISTRATION": "Government Issued Vehicle Registration",
    "HEALTH_CARD": "Health Card",
    "ID": "ID",
    "INDIAN_STATUS_CARD": "Indian Status Card",
    "INSURANCE_DOCUMENT": "Insurance Document",
    "INVESTMENT_ACCOUNT_STATEMENT": "Investment Account Statement",
    "LOAN_ACCOUNT_STATEMENT": "Loan Account Statement",
    "MARRIAGE_LICENCE": "Marriage License",
    "MICRO_DEPOSIT": "Micro Deposit",
    "MILITARY_ID": "Military ID",
    "NEXUS": "Nexus",
    "OTHER": "Other",
    "PASSPORT": "Passport",
    "PERMANENT_RESIDENT_CARD": "Permanent Resident Card",
    "PROCESSED_CHEQUE": "Processed Cheque",
    "PROPERTY_TAX_ASSESSMENT": "Property tax Assessment",
    "PROVINCIAL_ID": "Provincial ID",
    "RECORD_OF_EMPLOYMENT": "Record of Employment",
    "SCHOOL_DOCUMENT": "School Document",
    "SOCIAL_SECURITY_CARD": "Social Security Card",
    "STATE_ID": "State ID",
    "TRAVEL_VISA": "Travel Visa",
    "UTILITY_STATEMENT": "Utility Statement"
  },
  "secondaryDocumentType": "Secondary Document Type",
  "secondaryDocumentIssuingJurisdication": "Secondary Document Issuing Jurisdiction",
  "secondaryDocumentExpiryDate": "Secondary Document Expiry Date",
  "secondaryDocumentID": "Secondary Document ID",
  "secondaryDocumentUserName": "Secondary Document ID",
  "clientNameOnDocument": "Client name On Document",
  "documentOne": "Document 1",
  "documentTwo": "Document 2",
  "secondaryDocumentName": "Secondary Document Name",
  "documentName": "Document name",
  "documentID": "Document ID",
  "nameOnTheID": "Name on the ID",
  "creditFileSource": "Credit File Source",
  "documentIssuingJurisdication": "Document Issuing Jurisdiction",
  "expiryDate": "Document Expiry Date",
  "expiryDateError": "Document expiry date must be in the future",
  "verifiedDate": "Verified Date",
  "selectTheme": "Portfolio Theme",
  "selectProduct": "Select Product",
  "selectModel": "Select Model",
  "requireInvestorPolicyStatement": "Require Investor Policy Statement",
  "allowClientDeposits": "Allow Client Deposits",
  "timeHorizon": "Time Horizon",
  "timeHorizonOptions": {
    "VERY_SHORT_TERM": "Less than 1 year",
    "SHORT_TERM": "In 1 - 3 years",
    "MID_TERM": "In 4 - 6 years",
    "LONG_TERM": "In 7 or more years",
    "VERY_LONG_TERM": "Very Long Term"
  },
  "goalTimeHorizon": {
    "VERY_SHORT_TERM": "Very Short Term",
    "SHORT_TERM": "Short Term",
    "MID_TERM": "Mid Term",
    "LONG_TERM": "Long Term",
    "VERY_LONG_TERM": "Very Long Term"
  },
  "targetAmount": "Target Amount",
  "sign": "Sign",
  "review": "Review",
  "done": "Done",
  "document": "Document",
  "status": "Status",
  "clientAgreements": "Client",
  "signed": "Signed",
  "notSigned": "Not Signed",
  "formPackage": "Form Package",
  "signingViewPreview": "Preview & Sign",
  "signingPreviewDialogTitle": "Sign documents",
  "signingViewUrlMissing": "Signing link is not available yet.",
  "formPackStates": {
    "DRAFT": "Draft",
    "SENT": "Sent",
    "COMPLETED": "Completed",
    "ARCHIVED": "Archived",
    "DECLINED": "Declined",
    "OPTED_OUT": "Opted Out",
    "EXPIRED": "Expired"
  },
  "reviewed": "Reviewed",
  "notReviewed": "Not Reviewed",
  "uploadSigned": "Upload Signed File",
  "uploaded": "Uploaded",
  "pending": "Pending",
  "upload": "Upload",
  "signAndViewNext": "Sign and view next",
  "reviewNext": "Review next",
  "viewNext": "View Next",
  "continue": "Continue",
  "update": "Update",
  "downloadTemplate": "Download Template",
  "signAll": "Sign all",
  "signAllAndContinue": "Sign all and continue",
  "signAndContinue": "Sign and continue",
  "nothingToSign": "No new documents to sign",
  "buttons": {
    "addGoal": "Add Goal",
    "viewPDF": "View PDF"
  },
  "subAccountModal": {
    "editTitle": "Edit Sub-account",
    "addTitle": "Add New Sub-account",
    "requireInvestorPolicyStatement": "Require Investor Policy Statement",
    "allowFractionalShares": "Allow Fractional Shares",
    "liquidated": "Sub-account Liquidated",
    "liquidatedNoTooltip": "To change the liquidation state, initiate a withdraw-all transfer.",
    "liquidatedYesTooltip": "By changing this, future dividends will NOT be automatically sent to the client."
  },
  "billingModal": {
    "title": "Edit Sub-account Billing",
    "billingCycle": "Billing Cycle"
  },
  "accountDetails": {
    "transitions": {
      "active": "Transition to Active",
      "request": "Transition to Requested",
      "fail": "Transition to Fail",
      "cancel": "Transition to Cancel",
      "freeze": "Transition to Freeze",
      "ready": "Transition to Ready",
      "title": "Account Details"
    },
    "updateAccNo": "Update Account Number",
    "viewStates": "View State History",
    "asociateAccountToHousehold": "Change to Household account",
    "asociateAccountToNamedHousehold": "Change to {{name}} Household account",
    "dissociateAccountFromHousehold": "Dissociate from Household",
    "closeAccount": "Close Account",
    "forceOpen": "Force Open Account",
    "forceOpenSuccess": "The account will be sent to the custodian for account opening upon completion of pending approvals."
  },
  "statements": {
    "custom": "Custom",
    "awaitingReview": "Awaiting review",
    "yearToDate": "Year to date",
    "reconciled": "Reconciled",
    "allTime": "All time",
    "tax": "Tax",
    "any": "Any",
    "statements": "Statements",
    "managementFees": "Management fees",
    "failed": "Failed",
    "lastYear": "Last year",
    "byPeriod": "By Period",
    "fromDate": "From",
    "toDate": "To",
    "typeGroup": "Type",
    "state": "State",
    "accountType": "Account type",
    "thereAreNoStatements": "There are no statements to display"
  },
  "notes": {
    "types": {
      "ORGANIZATIONAL": "Organizational",
      "PRIVATE": "Private",
      "PUBLIC": "Public"
    },
    "subTitile": "Write a note",
    "title": "Notes"
  },
  "taxLossHarvesting": "Tax-Loss Harvesting",
  "documents": {
    "regeneratedToastMessage": "PDF has been regenerated.",
    "regenerate": "Regenerate PDF",
    "title": "Documents",
    "addDocument": "Add Document",
    "searchByName": "Document name",
    "typeToSearch": "Type to search",
    "docType": "Document type",
    "docState": "State",
    "any": "Any",
    "name": "name",
    "associatedTo": "associated to",
    "dateUpdated": "Date updated",
    "dateSigned": "Date signed",
    "state": "state",
    "PENDING": "Pending",
    "SIGNED": "Signed",
    "SAVED": "Saved",
    "signDigitally": "SIGN DIGITALLY",
    "uploadSignedDocument": "UPLOAD SIGNED DOCUMENT",
    "downloadTemplate": "DOWNLOAD TEMPLATE",
    "signConfirmationContent": "You are going to sign this document as {{onBehalfOf}}.",
    "signConfimationTitile": "Sign Document",
    "proceedDelete": "Yes, Delete",
    "cancelDelete": "No, Don't Delete",
    "deleteConfirmationContent": "Are you sure want to delete this document?",
    "deleteConfirmationTitle": "Delete Document",
    "downloadHtmlAsPdf": "Download/Print",
    "uploadNewVersion": "Upload New Version",
    "htmlSection": "HTML Document",
    "pdfSection": "PDF Document",
    "allowClientToView": "Enable client to view the document",
    "preventClientToView": "Do not allow client to view the document",
    "sendToCustodian": "Enable file to be shared with custodian",
    "status": "Status",
    "fileName": "document file",
    "download": "Download",
    "uploadDocument": "UPLOAD DOCUMENT",
    "deleteDocument": "Delete",
    "previewNotAvailable": "Preview is not available",
    "agreementNotAvailable": "Agreement is not available",
    "clientName": "Client name",
    "type": "Type",
    "cantSignDigitallyPleaseUpload": "This document can't be signed digitally yet. Please upload a signed file instead.",
    "documentHasBeenUploaded": "Document has been uploaded"
  },
  "documentUpload": {
    "documentUpload": "Document Upload",
    "documentName": "Document name",
    "documentType": "Document type",
    "associatedTo": "Associated to",
    "uploadDocument": "Upload document"
  },
  "droppableFileInput": {
    "dragFilesHere": "Drag & Drop a file here",
    "or": "or",
    "chooseAFile": "Choose a file",
    "chooseAnotherFile": "Choose another",
    "fileSize": "File size",
    "oneFileAtATime": "One file at a time, please"
  },
  "clientGroupSummary": {
    "establishedDate": "established date",
    "client": "client",
    "clients": "clients",
    "inThisGroup": "in this group",
    "editClientGroupProfile": "edit client group profile"
  },
  "clientGroupType": {
    "BUSINESS": "Business",
    "HOUSEHOLD": "Household"
  },
  "goalsSummary": {
    "header": "Goals",
    "addGoalBtn": "ADD GOAL",
    "ofTargetAmount": "of target amount",
    "subAccountsLinked_one": "1 sub-account linked",
    "subAccountsLinked_other": "{{count}} sub-accounts linked",
    "subAccountNeedsApproval_one": "1 sub-account need approval",
    "subAccountNeedsApproval_other": "{{count}} sub-accounts need approval",
    "goalStateLabel": "Goal State",
    "noGoals": "You don't have any goals",
    "goalState": {
      "ACTIVE": "Active",
      "COMPLETED": "Completed",
      "ARCHIVED": "Closed"
    },
    "externalHoldingsLinked_one": "1 Holding linked",
    "externalHoldingsLinked_other": "{{count}} Holdings linked"
  },
  "accountsSummary": {
    "header": "Accounts",
    "repCodeLabel": "Rep code",
    "repCodeNotAssigned": "Not assigned",
    "subAccountsLinked_one": "1 sub-account linked",
    "subAccountsLinked_other": "{{count}} sub-accounts linked",
    "ofTotalAssets": "{{percentage}} of total assets",
    "addAccountBtn": "ADD ACCOUNT",
    "accountStateLabel": "Account State",
    "noAccounts": "You don't have any accounts",
    "externalHoldingsLinked_one": "1 Holding linked",
    "externalHoldingsLinked_other": "{{count}} Holdings linked"
  },
  "clientReportSummary": {
    "header": "Client Reports",
    "noReports": "You currently have no reports.",
    "noReportsFiltered": "No reports match your search criteria"
  },
  "holdingsSummary": {
    "noHoldings": "You don't have any holdings"
  },
  "subAccountsSummary": {
    "header": "Portfolios",
    "noSubAccounts": "You don't have any portfolios"
  },
  "accountsGroup": {
    "tableHeaders": {
      "name": "Account Group Name",
      "numberOfAccounts": "Number of Accounts",
      "organization": "Organization"
    },
    "columnHeaders": {
      "client": "Client",
      "accountName": "Account Name/Type",
      "marketValue": "Market Value"
    },
    "createAccountGroup": "Create an account group",
    "groupName": "Group Name",
    "dragAccounts": "Drag in accounts to create group",
    "newGroup": "+ New Group",
    "ungroupedAccounts": "Ungrouped Accounts",
    "searchUngroupedAccounts": "Search Ungrouped Accounts",
    "searchAccountGroupAccounts": "Search Account Group Accounts",
    "addAccount": "Add Account",
    "createGroup": "Create Group",
    "removeFromGroup": "Remove from group",
    "deleteGroup": "Delete group",
    "viewGroup": "View",
    "seeMore": "See more",
    "view": {
      "list": "List View",
      "group": "Group View"
    },
    "totalAccount_one": "{{count}} account",
    "totalAccount_other": "{{count}} accounts"
  },
  "assetsOverview": {
    "marketValue": "Market Value",
    "totalAssets": "Total Assets",
    "totalSomeonesAssets": "{{name}}'s Assets",
    "cashAvailable": "Cash Available",
    "netContributions": "Net Contributions",
    "simpleRoR": "Simple ROR",
    "timeWeightedRoR": "Time Weighted Rate of Return",
    "timeWeightedRoRAbbreviation": "TWRR",
    "moneyWeightedRoR": "Money Weighted of Return",
    "moneyWeightedRoRAbbreviation": "MWRR",
    "cashOnHoldToWithdraw": "Cash on Hold to Withdraw",
    "cashOnHoldToTrade": "Cash on Hold to Trade",
    "newContributionsToday": "New Contributions (Today)",
    "contributionsToDate": "Contributions to date",
    "allocationOfTotalInvestments": "Allocation of total investments",
    "holdings": "Holdings",
    "missingExchangeRateMessage": "Exchange rate is not available",
    "emptyChart": "No history available",
    "MAX": "MAX",
    "YTD": "YTD",
    "1Y": "1Y",
    "3M": "3M",
    "1M": "1M",
    "6M": "6M",
    "5Y": "5Y",
    "customDateRange": "Custom Date"
  },
  "performanceMetricsModal": {
    "title": "Performance Metrics",
    "timeWeightedReturns": "Time-Weighted Rate of Return (TWRR)",
    "moneyWeightedReturns": "Money-Weighted Rate of Return (MWRR)",
    "simpleRateOfReturn": "Simple Rate of Return",
    "fxRate": {
      "title": "FX rate",
      "body": "{{from}} converted to {{to}} at the following rate: {{rate}}"
    }
  },
  "coporateAccounts": {
    "govFundOptions": {
      "ADDITIONAL_CESG": "ADDITIONAL CESG",
      "BASIC_CESG": "BASIC CESG",
      "CLB": "CLB"
    },
    "newAccount": {
      "createAccount": "Create Corporate Account",
      "selectGovernmentFund": "Select Government Funds",
      "enableTLH": "Enable Tax Loss Harvesting",
      "selectCorporateUser": "Select Corporate User"
    },
    "relationshipOptions": {
      "PRIMARY_BENEFICIARY": "Beneficiary",
      "CONTINGENT_BENEFICIARY": "Contingent Beneficiary",
      "AUTHORIZED_INDIVIDUAL": "Authorized Individual",
      "OTHER": "Other",
      "TRUSTEE": "Trustee",
      "POWER_OF_ATTORNEY": "Power Of Attorney",
      "JOINT": "Joint",
      "BENEFICIAL_OWNER": "Beneficial Owner",
      "SUCCESSOR": "Successor"
    }
  },
  "incompleteFields": "Incomplete Fields",
  "padAgreement": "Pad-agreement",
  "frequency": {
    "BI_WEEKLY": "Bi-Weekly",
    "DAILY": "Daily",
    "LAST_DAY_OF_THE_MONTH": "Last day of the month",
    "MONTHLY": "Monthly",
    "ONE_TIME": "One-time",
    "SEMI_MONTHLY": "Semi-Monthly",
    "WEEKLY": "Weekly",
    "ANNUAL": "Annually",
    "QUARTERLY": "Quarterly",
    "SEMESTRAL": "Semestral"
  },
  "padAgreementTitle": "Pad Agreement",
  "canceled": "CANCELED",
  "accountHolder": "Account Holder",
  "tradingProcessItems": {
    "INHERITED_FROM_PARENT": "Inherited from parent organization",
    "NO_AUTOMATION": "No automation",
    "PORTFOLIO_OPTIMIZER": "Portfolio optimizer",
    "REBALANCE_V1": "Rebalance v1",
    "REBALANCE_V2": "Rebalance v2"
  },
  "optimizerProcessItems": {
    "PORTFOLIO_OPTIMIZER_V1": "Optimizer V1 (default)",
    "PORTFOLIO_OPTIMIZER_V2": "Optimizer V2"
  },
  "tradingProcess": "Trading Process",
  "overrideAccountsTaxRanks": "Override accounts tax ranks",
  "accountTypes": "Account Types",
  "overrideTaxRanks": "Override Tax Ranks",
  "defaultTaxRanks": "Default Tax Ranks",
  "other": "Other",
  "formTypes": {
    "FORM": "Form",
    "INVOICE": "Invoice",
    "NOTES": "Notes",
    "OTHER": "Other",
    "STATEMENT": "Statement",
    "BANKING": "Banking",
    "LOGO": "Logo",
    "ID_VERIFICATION": "ID Verification"
  },
  "primaryDocument": "Document 1: Address Verification",
  "secondaryDocument": "Document 2: Date of Birth Verification",
  "supportingDocuments": "Supporting Documents",
  "supportingDocument": "Supporting Document",
  "holdings": "Holdings",
  "welcome": "Welcome",
  "affiliates": {
    "title": "Affiliates",
    "addNewAffiliate": "Add new affiliate"
  },
  "personalInformation": {
    "title": "Personal Information"
  },
  "personOfInterest": {
    "title": "Person of interest"
  },
  "employmentInformation": {
    "title": "Employment Information"
  },
  "nonIndividualInformation": {
    "title": "Non Individual Information"
  },
  "incomeAssetsAndDebts": {
    "title": "Income assets and debts"
  },
  "scheduletransfers": {
    "title": "Schedule Transfers"
  },
  "relationshipInformation": {
    "title": "Relationship Information"
  },
  "suitability": {
    "title": "Suitability"
  },
  "reviewBankAccountInformation": {
    "title": "Review bank Account Information"
  },
  "accountTable": {
    "account": "Account",
    "name": "Name",
    "accountHolder": "Holder",
    "accountNumber": "Account #",
    "program": "Program",
    "percentOfTotal": "% of Total",
    "gainsAndLosses": "G/L Unrealized",
    "currentValue": "Current Value",
    "total": "Total"
  },
  "holdingTable": {
    "symbolName": "Symbol - Name",
    "quantity": "Quantity",
    "bookCost": "Book Cost",
    "currentPrice": "Current Price",
    "percentOfTotal": "% of Total",
    "gainsAndLosses": "G/L Unrealized",
    "1DayChange": "1-Day Change",
    "currentValue": "Current Value"
  },
  "editHousehold": {
    "edit": "Edit",
    "editHousehold": "Edit Household",
    "archive": "Archive",
    "name": "Household Name",
    "archiveHouseholdConfirmation": {
      "title": "Are you sure?",
      "bodyText": "There are {{numOfMembers}} client(s) in this household. This will not delete the client’s information, but they will no longer be associated with this household."
    }
  },
  "editGoal": {
    "editGoal": "Edit Goal",
    "edit": "Edit",
    "close": "Close",
    "goalName": "Goal Name",
    "targetAmount": "Target Amount",
    "cancel": "Cancel",
    "closeGoal": "Are you sure?",
    "closeGoalText": "Before closing a goal, you must close any portfolios associated with the goal."
  },
  "goalInformation": {
    "title": "Goal Information"
  },
  "editSubAccount": {
    "close": "Close",
    "activate": "Activate",
    "cancel": "Cancel",
    "review": "Review",
    "closeSubAccount": "Are you sure?",
    "closeSubAccountText": "Before closing portfolio, ensure that there are zero funds."
  },
  "editAccount": {
    "close": "Close",
    "edit": "Edit",
    "cancel": "Cancel",
    "closeAccount": "Are you sure?",
    "editAccount": "Edit Account",
    "closeAccountText": "Before closing an account, you must close any portfolios associated with the account."
  },
  "editAccountGroup": {
    "title": "Edit Account Group",
    "edit": "Edit Group",
    "delete": "Delete Group",
    "confirm": "Confirm",
    "cancel": "Cancel",
    "groupNameRequired": "Group name is required",
    "noAccountsInGroup": "At least one account is required",
    "closeAccountGroup": "Are you sure?",
    "closeAccountGroupText": "Are you sure you want to delete this account group?",
    "greyedAccountsCopy": "Greyed out accounts have either been closed or are frozen"
  },
  "riskReturnLevels": {
    "VERY_LOW": "Very Low Risk",
    "LOW": "Low Risk",
    "MEDIUM": "Medium Risk",
    "HIGH": "High Risk",
    "VERY_HIGH": "Very High Risk"
  },
  "portfolioBreakdown": "Portfolio Breakdown",
  "currentPortfolio": "Current Portfolio",
  "recommendedPortfolio": "Recommended Portfolio",
  "idVerifications": {
    "secondaryDocumentType": "Information Type",
    "secondaryDocumentIssuingJurisdication": "Information Source",
    "secondaryDocumentExpiryDate": "Expiry Date",
    "secondaryDocumentID": "Document Reference Number",
    "secondaryDocumentUserName": "Secondary Document ID",
    "clientNameOnDocument": "Client Name On Document",
    "documentOne": "Document 1",
    "documentTwo": "Document 2",
    "toggleDocumentA11y": "Toggle ID document",
    "secondaryDocumentName": "Secondary Document Name",
    "documentName": "Document name",
    "documentID": "Document Reference Number",
    "nameOnTheID": "Name on the ID",
    "documentType": "Information Type",
    "creditFileSource": "Credit File Source",
    "documentIssuingJurisdication": "Information Source",
    "expiryDate": "Expiry Date",
    "verifiedDate": "Verified Date",
    "idVerificationMethods": {
      "CREDIT_CHECK": "Credit Check",
      "DIGITAL_DOCUMENT_CHECK": "Digital Document Check",
      "DUAL_METHOD": "Dual Process Method",
      "IN_PERSON_VALIDATION": "In Person Validation"
    },
    "address": "Document Address",
    "secondaryDocumentDateOfBirth": "Document Date of Birth",
    "secondaryDocumentVerifiedDate": "Verified Date",
    "documentOneAddress": "Document 1: Address Verification",
    "documentTwoDateOfBirth": "Document 2: Date of Birth Verification",
    "dateOfBirthValidation": "Date of birth must be in the past.",
    "underAgeValidation": "Client must be at least {{MINUMUM_AGE}} years old."
  },
  "saveAndContinue": "Save and Continue",
  "noAffiliates": "There are no affiliates assigned to this account",
  "bankAccount": {
    "youDontHaveAnyLinkedBankAccounts": "You don’t have any linked bank accounts",
    "addAnotherbankAccount": "Add another bank account",
    "tdBank": "TD Bank",
    "bmoBank": "BMO Bank",
    "scotiaBank": "Scotiabank",
    "rbcBank": "Royal Bank of Canada",
    "nationalBankOfCanada": "National Bank of Canada",
    "cibc": "Canadian Imperial Bank of Commerce",
    "hsbcBank": "HSBC Bank Canada",
    "canadaWesternTrustBank": "Canadian Western Bank",
    "LauentianBank": "Laurentian Bank of Canada",
    "atbBank": "ATB Bank",
    "manulifeBank": "Manulife Bank of Canada",
    "eqLifeBank": "EQ Bank",
    "tangerineBank": "Tangerine Bank",
    "flinksBank": "Flinks",
    "coastCapitalBank": "Coast Capital",
    "desjardinsBank": "Desjardins Bank",
    "meridianBank": "Meridian Bank",
    "defaultBank": "Bank",
    "deleteBankAccountTitle": "Delete Bank Account",
    "deleteBankAccountDesc": "Are you sure you want to delete this bank account from your account? Once deleted, the account must be re-added if you reconsider.",
    "confirm": "Confirm",
    "bankAccountName": "Bank Account Name",
    "deleteAccount": "Delete Account",
    "save": "Save",
    "editBankAccount": "Edit Bank Account"
  },
  "taxLotDetails": "Lot Details",
  "newTaxLotTitle": "New Lot",
  "taxLotTable": {
    "openDate": "Open Date",
    "quantity": "Quantity",
    "price": "Price",
    "costBasis": "Cost Basis",
    "marketValue": "Market Value",
    "gainsLoss": "Gains/Losses",
    "noTaxLots": "No lots have been added to this holding"
  },
  "newTaxLot": {
    "quantity": "Quantity",
    "price": "Price",
    "date": "Open Date"
  },
  "portfolioTargetHoldings": "Portfolio Target Holdings",
  "viewFundsFacts": "View Fund Facts",
  "total": "Total",
  "additionAccountInformation": "Additional Account Information",
  "holdingsProgressTitle": "Packaging Holdings",
  "holdingsTable": {
    "symbol": "Symbol",
    "securityName": "Security Name",
    "quantity": "Quantity",
    "bookCostNative": "Book Cost (Native)",
    "bookCost": "Book Cost",
    "bookValue": "Book Value",
    "localCost": "Local Cost",
    "nativeCost": "Native Cost",
    "localBookValue": "Local Book Value",
    "nativeBookValue": "Native Book Value",
    "custodianBookValue": "Custodian Book Value",
    "currentPriceNative": "Current Price (Native)",
    "currentPrice": "Current Price",
    "unrealizedGainLossCents": "G/L Unrealized (Cents)",
    "unrealizedGainLossPercentage": "G/L Unrealized (%)",
    "oneDayChangeCents": "1-Day Change (Cents)",
    "oneDayChangePercentage": "1-Day Change (%)",
    "percentOfTotal": "% of Total",
    "currentValue": "Current Value",
    "marketValueNative": "Market Value (Native)",
    "marketValue": "Market Value",
    "type": "Type",
    "name": "Name",
    "fundSeries": "Fund Series"
  }
}
